// eslint-disable-next-line import/prefer-default-export
export {
  default as AgencyProfileCard,
  type AgencyProfileCardProps,
} from './agency-profile-card';
